import { connect } from 'react-redux'
import { setMenuSelectedState } from 'store/menu-selected/actions'
import ContractedHours from './ContractedHours'


const mapStateToProps = state => ({
  contractedHours: state.contractedHours,
})

const mapDispatchToProps = dispatch => ({
  setMenuSelectedState: (state) => {
    dispatch(setMenuSelectedState(state))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ContractedHours)



// WEBPACK FOOTER //
// ./src/components/ContractedHours/index.jsx